const labelAnim = {
  init() {
    /* Smooth content */

    ScrollSmoother.create({
      wrapper: "#smooth-container",
      content: "#smooth-content",
      smooth: 1,
      effects: true,
    });

    /* POSTERS */

    let posters = document.querySelectorAll(".poster")

    gsap.matchMedia().add("(min-width: 768px)", () => {
      gsap.from(".label-logo", {
        scrollTrigger: {
          trigger: "#label",
          start: "top center",
          scrub: false,
          end: "+=100%",
          markers: false,
        },
        y: 200,
        opacity: 0,
        stagger: 0.5,
        duration: 1,
      });
      gsap.from(".label-description", {
        scrollTrigger: {
          trigger: "#label",
          start: "top center",
          scrub: false,
          end: "+=100%",
          markers: false,
        },
        y: 200,
        opacity: 0,
        stagger: 0.5,
        duration: 1,
      });

      if(posters.length > 0){
        gsap.from(".poster", {
          scrollTrigger: {
            trigger: "#label",
            start: "top center",
            scrub: false,
            end: "+=100%",
            markers: false,
          },
          y: 200,
          opacity: 0,
          stagger: {
            each: 0.1,
            from: 'center',
          },
          duration: 1,
        });
      }
    });
  

    gsap.matchMedia().add("(max-width: 767px)", () => {
      gsap.from(".label-logo", {
        scrollTrigger: {
          trigger: "#label",
          start: "top center",
          scrub: false,
          end: "+=100%",
          markers: false,
        },
        y: 0,
        opacity: 0,
        stagger: 0.5,
        duration: 1,
      });
      gsap.from(".label-description", {
        scrollTrigger: {
          trigger: "#label",
          start: "top center",
          scrub: false,
          end: "+=100%",
          markers: false,
        },
        y: 0,
        opacity: 0,
        stagger: 0.5,
        duration: 1,
      });
      gsap.from(".poster", {
        scrollTrigger: {
          trigger: "#label",
          start: "top center",
          scrub: false,
          end: "+=100%",
          markers: false,
        },
        y: 0, // Adjust the y value for smaller screens
        opacity: 0,
        stagger: {
          each: 0.1,
          from: 'center',
        },
        duration: 1,
      });
    });

    /* TEAM BOARD */

    const teamPhotoWraps = document.querySelectorAll(".label-team-photos div");
    const teamDescriptions = document.querySelectorAll(
      ".label-team-description div"
    );

    const teamDescriptionSingle = document.querySelector('.label-team-description-single');
    if(teamDescriptionSingle){
      gsap.matchMedia().add("(min-width: 768px)", () => {
        gsap.from(teamDescriptionSingle, {
          scrollTrigger: {
            trigger: teamDescriptionSingle,
            start: "top 80%",
            scrub: false,
            end: "+=100%",
            markers: false,
          },
          y: 200,
          opacity: 0,
          stagger: 0.5,
          duration: 1,
        });
      })
    }

    teamPhotoWraps.forEach((wrap, index) => {
      wrap.addEventListener("mouseover", () => {
        teamPhotoWraps.forEach((desc, descIndex) => {
          if (index === descIndex) {
            desc.classList.add("active");
          } else {
            desc.classList.remove("active");
          }
        });

        teamDescriptions.forEach((desc, descIndex) => {
          if (index === descIndex) {
            gsap.fromTo(
              desc,
              {
                x: 100,
                duration: 0.5,
                opacity: 1,
                height: "fit-content",
                display: "block",
              },
              { x: 0 }
            );
            gsap.fromTo(
              desc.children,
              { opacity: 0 },
              { opacity: 1, y: 0, duration: 0.5, stagger: 0.1 }
            );
          } else {
            gsap.to(desc, {
              duration: 0,
              opacity: 0,
              height: 0,
              display: "none",
            });
          }
        });
      });
    });

    gsap.matchMedia().add("(min-width: 768px)", () => {
    gsap.from(".label-team-title", {
      scrollTrigger: {
        trigger: ".section-label-team",
        start: "top 80%",
        scrub: false,
        end: "+=100%",
        markers: false,
      },
      y: 200,
      opacity: 0,
      stagger: 0.5,
      duration: 1,
    });

    gsap.from(".team-photo-wrap", {
      scrollTrigger: {
        trigger: ".label-team-title",
        start: "top 80%",
        scrub: false,
        end: "+=100%",
        markers: false,
      },
      y: 200,
      opacity: 0,
      stagger: 0.3,
      duration: 1,
    });
  });

  gsap.matchMedia().add("(max-width: 767px)", () => {
    gsap.from(".label-team-title", {
      scrollTrigger: {
        //trigger: ".section-label-team",
        //start: "end end",
        scrub: false,
        end: "+=100%",
        markers: false,
      },
      y: 200,
      opacity: 0,
      stagger: 0.5,
      duration: 1,
    });
    gsap.from(".team-photo-wrap", {
      scrollTrigger: {
       // trigger: ".label-team-title",
        //start: "end end",
        scrub: false,
        end: "+=100%",
        markers: false,
      },
      y: 200,
      opacity: 0,
      stagger: 0.3,
      duration: 1,
    });

  });

    /* PRODUCTIONS SWIPERS */

    var swiper1 = new Swiper(".seriesSwiper", {
      slidesPerView: "auto",
      /* spaceBetween: 30, */
      //loop: true,
      freeMode: true,
      //centeredSlides: true,
      pagination: {
        el: ".swiper-pagination1",
        clickable: true,
      },
      navigation: {
        nextEl: ".swiper-button-next1",
        prevEl: ".swiper-button-prev1",
      },
    });

    var swiper2 = new Swiper(".filmsSwiper", {
      slidesPerView: "auto",
      /* spaceBetween: 30, */
      //loop: true,
      freeMode: true,
      //centeredSlides: true,
      pagination: {
        el: ".swiper-pagination2",
        clickable: true,
      },
      navigation: {
        nextEl: ".swiper-button-next2",
        prevEl: ".swiper-button-prev2",
      },
    });

    var swiper3 = new Swiper(".docuSwiper", {
      slidesPerView: "auto",
      /* spaceBetween: 30, */
      //loop: true,
      freeMode: true,
      //centeredSlides: true,
      pagination: {
        el: ".swiper-pagination3",
        clickable: true,
      },
      navigation: {
        nextEl: ".swiper-button-next3",
        prevEl: ".swiper-button-prev3",
      },
    });

    var swiper4 = new Swiper(".captationSwiper", {
      slidesPerView: "auto",
      /* spaceBetween: 30, */
      //loop: true,
      freeMode: true,
      //centeredSlides: true,
      pagination: {
        el: ".swiper-pagination4",
        clickable: true,
      },
      navigation: {
        nextEl: ".swiper-button-next4",
        prevEl: ".swiper-button-prev4",
      },
    });

    var swiper5 = new Swiper(".unitaireSwiper", {
      slidesPerView: "auto",
      /* spaceBetween: 30, */
      //loop: true,
      freeMode: true,
      //centeredSlides: true,
      pagination: {
        el: ".swiper-pagination5",
        clickable: true,
      },
      navigation: {
        nextEl: ".swiper-button-next5",
        prevEl: ".swiper-button-prev5",
      },
    });

    /* END OF PAGE ANIMATION */

    gsap.to(".productions-lists", {
        
      scrollTrigger: {
        trigger: "footer",
        start: "top bottom",
        scrub: true,
        end: "+=100%",
        markers: false,
      },
      width:"98%"
      });
  },
};

export default labelAnim;
